module.exports = __webpack_public_path__ + "img/bg.1b3fa509.png";